import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChannelProgressModel } from 'src/app/models/dashboard/channel-progress.model';
import { TableColumn } from 'src/app/models/table-column.model';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';

@Component({
  selector: 'app-channel-training-participants-widget',
  standalone: false,
  templateUrl: './channel-training-participants-widget.component.html',
  styleUrl: './channel-training-participants-widget.component.scss'
})
export class ChannelTrainingParticipantsWidgetComponent {
  channels: ChannelProgressModel[] = [];
  
  columns: TableColumn[] = [
    {
      dataField: 'channel',
      caption: this.translateService.instant('COMMON.FIELDS.CHANNEL'),
      disableFiltering: true
    },
    {
      dataField: 'participantsCount',
      caption: this.translateService.instant('CHANNEL-TRAINING-PARTICIPANTS.COUNT-OF-PARTICIPANTS'),
      disableFiltering: true
    },
    {
      dataField: 'distributionPercentage',
      caption:  this.translateService.instant('CHANNEL-TRAINING-PARTICIPANTS.DISTRIBUTION'),
      calculateDisplayValue: (rowData: ChannelProgressModel) => {
        return rowData.distributionPercentage + '%';
      },
      disableFiltering: true
    },
    {
      dataField: 'previousYearParticipantsCount',
      caption:  this.translateService.instant('CHANNEL-TRAINING-PARTICIPANTS.PREVIOUS-YEAR-PARTICIPANTS'),
      disableFiltering: true
    },
    {
      dataField: 'percentParticipantsChangeFromLastYear',
      caption:  this.translateService.instant('CHANNEL-TRAINING-PARTICIPANTS.COMPARED-TO-PREVIOUS-YEAR'),
      cellTemplate: 'percent',
      disableFiltering: true
    }
  ];

  constructor(
    private translateService: TranslateService,
    private dashboardWidgetsDataService: DashboardWidgetsDataService
  ) {

  }

  ngOnInit() {
    this.dashboardWidgetsDataService.getChannelProgressData().subscribe(data => {
      if (data) {
        this.channels = data;
      }
    });
  }
}
